import { ListItemKeyword } from "@similarweb/ui-components";

import type { Recent } from "app/custom-hooks/useRecentsHook";
import type { OnSearchItemClick } from "app/pages/activation/components/HomeSearch/types";

import { createKeywordUrl } from "./createKeywordUrl";
import { redirectToUrl } from "./redirectToUrl";

export const createRecentKeywordItem = (item: Recent, onClick?: OnSearchItemClick) => {
    const {
        data: { keyword, stateName },
        id,
    } = item;

    const url = createKeywordUrl(keyword, stateName);

    const onItemClick = () => {
        onClick?.(keyword, "recent");

        redirectToUrl(url);
    };

    return (
        <ListItemKeyword
            key={id}
            iconName="keywords"
            text={keyword}
            onClick={onItemClick}
        />
    );
};
